import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import { getDomainLocale } from './domains'

Vue.use(VueI18n)

// 检测浏览器语言
function detectBrowserLanguage() {
  const lang = navigator.language || navigator.browserLanguage
  if (lang && lang.toLowerCase().startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

// 语言优先级：手动选择（localStorage） > 域名默认 > 构建时语言（.env.en/.env.cn） > 浏览器语言
// 分域名方案下域名只决定"未手动选择过"时的默认语言（cn.szcofoe.com=中文 / www.szcofoe.com=英文）；
// 用户通过导航栏切换语言后记入 localStorage（按域名独立存储），刷新后保持，不做跨域名跳转
function getLocale() {
  // 手动切换过语言：以用户选择为准（localStorage 按域名隔离，两站偏好互不影响）
  const savedLang = localStorage.getItem('locale')
  if (savedLang && ['zh', 'en'].includes(savedLang)) {
    return savedLang
  }
  // 未手动选择过：按访问域名的默认语言
  const domainLocale = getDomainLocale()
  if (domainLocale) {
    return domainLocale
  }
  // 未识别域名（本地开发等）：按构建时目标语言兜底，便于预览对应构建产物
  const buildLocale = process.env.VUE_APP_SITE_LOCALE
  if (buildLocale && ['zh', 'en'].includes(buildLocale)) {
    return buildLocale
  }
  return detectBrowserLanguage()
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'zh',
  messages: {
    zh,
    en
  }
})

export default i18n
